import { LinkId } from '../../../common/AnalyticsContext/LinkId';
import { applyTrackingId } from '../../../common/AnalyticsContext/applyTrackingId';
import { HeImgix } from '../../../common/components/images/HeImgix';
import { Pill } from '../../FilterContainer/FilterPill/FilterPill.styles';

interface Props {
  logo: string;
  onClick?(): void;
  trackingId?: LinkId;
}

export const ProviderPill = ({ logo, onClick, trackingId }: Props) => {
  const trackingIdProps = applyTrackingId(trackingId);
  return (
    <Pill onClick={onClick} {...trackingIdProps}>
      <HeImgix
        src={logo}
        imgixParams={{ fit: 'fill', fill: 'color', 'fill-color': 'fff' }}
        height={16}
      />
    </Pill>
  );
};
